module.exports = __webpack_public_path__ + "img/icon-edit.f4de9ffb.svg";